export const windowsDeviceSoftwareApplicationInfoMap = [
  "name",
  "version",
  "size",
  "installed_date"
];

export const windowsDeviceSoftwareUpdateInfoMap = [
  "description",
  "hotfix_id",
  "installed_on"
];

export const androidDeviceSoftwareInfoMap = [
  "name",
  "app_name",
  "size",
  "version",
  "install_date"
];
